import { css } from '@emotion/core'

export const globalStyles = css`
  @font-face: {
    font-family: 'Biennale';
    src: url('../assets/fonts/biennale/biennale-regular.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  
  @font-face: {
    font-family: 'Biennale';
    src: url('../assets/fonts/biennale/biennale-bold.woff2') format('woff2');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
  
  @font-face: {
    font-family: 'Biennale';
    src: url('../assets/fonts/biennale/biennale-thin.woff2') format('woff2');
    font-weight: 200;
    font-style: normal;
    font-display: swap;
  }
  
  html {
    scroll-behavior: smooth;
  }
  
  * {
    outline: none;
  }
  
  body, input, textarea {
    font-family: 'Open Sans', sans-serif;
    background-color: white
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Biennale', sans-serif;
  }
  
  p {
    margin-bottom: 10px;
  }

  img {
    width: unset!important;
  }
  
  .embed-responsive {
    position: relative;
    &::before {
      height: 0;
      content: "";
      display: block;
      padding-bottom: 56.25%;
    }
    iframe {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }

  #my-webexteams-widget {
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
    right: 0;
  }

  .blocked {
    cursor: default;
  }
  .reply-comment {
    margin: 10px 0 0 70px!important;

    .sub-avatar {
      width: 2.2rem;
      height: 2.2rem;
    }

    @media (max-width: 768px) {
      margin: -20px 0 0 30px!important;
    }
  }

  .fadeOut{
    opacity:0;
    width:0;
    height:0;
    transition: width 0.5s 0.5s, height 0.5s 0.5s, opacity 0.3s;

  }
  .fadeIn{
    opacity:1;
    transition: width 0.5s, height 0.5s, opacity 0.5s 0.3s;
  }  
`
